@let appForSelectedCategory = appsForSelectedCategory();
<mat-card [class.grow-visible]="isVisible()" class="sphere-density__comfortable AppSwitcher" appearance="outlined">
    <mat-card-header>
        <button class="sphere-density__compact" mat-icon-button (click)="closeSelf()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content class="AppSwitcherWrapper">
        <div>
            <mat-nav-list>
                <a mat-list-item class="SwitcherApp" [routerLink]="['/', 'home']" (click)="closeSelf()">
                    <div matListItemIcon>
                        <mat-icon>dashboard</mat-icon>
                    </div>
                    <span matListItemTitle> Home </span>
                </a>
            </mat-nav-list>

            @if (legacyMode()) {
                <ng-container [ngTemplateOutlet]="appNavList" [ngTemplateOutletContext]="{ apps: featuredApps() }"></ng-container>
            } @else {
                <mat-action-list>
                    <h4 matSubheader class="text-subtle">Categories</h4>
                    <button
                        mat-list-item
                        class="SphereAppCategory"
                        [ngClass]="{ SphereAppCategory__Active: !selectedCategory() }"
                        (click)="selectCategory(null)"
                    >
                        All apps
                    </button>
                    @for (category of sphereAppCategories(); track $index) {
                        <button
                            mat-list-item
                            class="SphereAppCategory"
                            [ngClass]="{ SphereAppCategory__Active: category.category === selectedCategory() }"
                            (click)="selectCategory(category.category)"
                        >
                            {{ category.category }}
                        </button>
                    }
                </mat-action-list>
            }
        </div>

        <mat-divider vertical class="AppSwitcherDivider AppSwitcherDivider__Vertical" />

        @if (legacyMode()) {
            <div>
                <ng-container [ngTemplateOutlet]="appNavList" [ngTemplateOutletContext]="{ apps: apps() }"></ng-container>
            </div>
        } @else {
            <div>
                @if (hasFavorites()) {
                    <ng-container
                        [ngTemplateOutlet]="appNavList"
                        [ngTemplateOutletContext]="{ apps: appForSelectedCategory?.favorites, favorites: true }"
                    ></ng-container>
                }

                @if (hasFavorites() && hasNonFavorites()) {
                    <mat-divider class="AppSwitcherDivider AppSwitcherDivider__Horizontal" />
                }

                @if (hasNonFavorites()) {
                    <ng-container [ngTemplateOutlet]="appNavList" [ngTemplateOutletContext]="{ apps: appForSelectedCategory.apps }"></ng-container>
                }
                @if (!hasApps()) {
                    <p class="no-apps-message">
                        We're sorry, you are not authorized to use any application. Please contact your system administrator.
                    </p>
                }
                s
            </div>
        }
    </mat-card-content>
</mat-card>

<ng-template #appNavList let-apps="apps" let-favorites="favorites">
    <mat-nav-list>
        @for (app of apps; track $index) {
            @if (app.data.isAvailable) {
                <a mat-list-item class="SwitcherApp" [routerLink]="['/', app.path]" (click)="closeSelf()">
                    <div matListItemIcon style="background-size: cover" [style.background-image]="getLogo(app.data['logoSvg'])"></div>
                    <span matListItemTitle>
                        {{ app.data?.name }}
                    </span>
                    <span matListItemMeta class="AppListItemMeta">
                        @if (app.data?.alpha) {
                            <sphere-experimental-tag featureStage="alpha" />
                        } @else if (app.data?.beta) {
                            <sphere-experimental-tag featureStage="beta" />
                        }
                        @if (!legacyMode()) {
                            <button
                                mat-icon-button
                                class="FavoriteToggle sphere-density__compact"
                                [ngClass]="{ 'FavoriteToggle--IsFavorite': favorites }"
                                (click)="toggleFavorite($event, app, favorites)"
                                [matTooltip]="favorites ? 'Remove from favorite apps' : 'Add to favorite apps'"
                                matTooltipPosition="after"
                            >
                                <mat-icon>{{ favorites ? 'star' : 'star_outline' }}</mat-icon>
                            </button>
                        }
                    </span>
                </a>
            }
        }
    </mat-nav-list>
</ng-template>
